import { useEffect, useState } from "react";

/** Becomes true (and stays true) once the visitor has scrolled past `threshold` (0–1) of the page. */
export function useScrollProgressReveal(threshold = 0.5) {
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    if (revealed) return;
    const check = () => {
      const doc = document.documentElement;
      const scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable > 0 && window.scrollY / scrollable >= threshold) setRevealed(true);
    };
    check();
    window.addEventListener("scroll", check, { passive: true });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, [revealed, threshold]);

  return revealed;
}
